import { make } from 'redux-chill';

import type { Pricing } from '../types';

const setPricingInfo = make('[delivery] set pricing')
  .stage((info: Pricing) => ({ info }))
  .stage('reset');

export { setPricingInfo };
